import { useState } from "react";
import { toast } from "sonner";
import { Mail, Check, Send } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

export default function TipSubscribe() {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setSubmitting(true);
    try {
      await api.post("/tips/subscribe", { email, name: name || null });
      setDone(true);
      toast.success("You're subscribed. Look out for the 1st of next month.");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section
      id="tip-subscribe"
      data-testid="tip-subscribe-section"
      className="py-20 md:py-24 bg-background border-t border-border"
    >
      <div className="container-ic">
        <div className="border border-border bg-card/30 p-8 md:p-12 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-6">
            <div className="overline mb-4">
              <Mail className="inline h-3.5 w-3.5 mr-2 -mt-0.5" />
              Monthly Yard Tips
            </div>
            <h2 className="font-display text-3xl md:text-5xl font-black uppercase tracking-tighter leading-[0.95]">
              The right move,
              <br />
              <span className="text-primary">every month.</span>
            </h2>
            <p className="mt-5 text-muted-foreground text-base md:text-lg max-w-md leading-relaxed">
              One short email on the 1st of each month — the one yard task that matters
              most for Central Texas right now. No spam. Unsubscribe anytime.
            </p>
          </div>

          <div className="lg:col-span-6">
            {done ? (
              <div
                className="border border-primary/40 bg-primary/5 p-6 text-center"
                data-testid="tip-subscribe-success"
              >
                <Check className="h-8 w-8 text-primary mx-auto mb-3" />
                <div className="font-display text-xl font-bold uppercase tracking-tight">
                  You're on the list.
                </div>
                <p className="text-sm text-muted-foreground mt-2">
                  Your first tip arrives on the 1st of next month at 9:00 AM CT.
                </p>
              </div>
            ) : (
              <form
                onSubmit={onSubmit}
                className="space-y-4"
                data-testid="tip-subscribe-form"
              >
                <input
                  type="text"
                  placeholder="First name (optional)"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="w-full bg-background border border-border px-4 py-3 focus:border-primary outline-none text-foreground placeholder:text-muted-foreground"
                  data-testid="tip-subscribe-name"
                />
                <input
                  type="email"
                  required
                  placeholder="Your email address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full bg-background border border-border px-4 py-3 focus:border-primary outline-none text-foreground placeholder:text-muted-foreground"
                  data-testid="tip-subscribe-email"
                />
                <button
                  type="submit"
                  disabled={submitting}
                  className="btn-primary w-full disabled:opacity-60"
                  data-testid="tip-subscribe-submit"
                >
                  {submitting ? (
                    "Subscribing…"
                  ) : (
                    <>
                      <Send className="h-4 w-4" /> Subscribe — Free
                    </>
                  )}
                </button>
                <p className="text-[11px] text-muted-foreground text-center">
                  By subscribing, you agree to receive one yard-care email per month
                  from Ironclad Yard Services.
                </p>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
